import { useState, useMemo, lazy, Suspense } from "react";
import NewLogin from "./login/NewLogin"; 
import { LoginContext } from "./login/context/LoginContext"; 
import { TargetContext } from "./track/context/TargetContext.js";
import { retryLazy } from "./utils/retryLazy.js";
import ErrorBoundary from "./utils/ErrorBoundary.js";
import { SnackbarProvider, closeSnackbar } from "notistack";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Routes,
  Route,
} from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { RedisHealthReconciliationBridge } from "./graphql/RedisHealthReconciliationBridge";
import { GlobalRealtimeStatus } from "./graphql/GlobalRealtimeStatus";

const MainPage = lazy(() => retryLazy(() => import('./main/MainPage.js')));
const WhiteList = lazy(() => retryLazy(() => import('./WhiteList/components/WhiteList.js')));
const TrackPage = lazy(() => retryLazy(() => import('./track/components/TrackPage.js')));
const ManagePage = lazy(() => retryLazy(() => import('./BasestationManage/components/ManagePage.js')));
const AuditLogPage = lazy(() => retryLazy(() => import('./AuditLog/components/AuditLogPage.js')));
const AdminPage = lazy(() => retryLazy(() => import('./Admin/components/AdminPage.js')));
const AccountPage = lazy(() => retryLazy(() => import('./Account/components/AccountPage.js')));

const App = () => {
  const [token, setToken] = useState(null);
  const [userAuthority, setUserAuthority] = useState(null);
  const [cluster, setCluster] = useState(null);
  const [clusterSwitching, setClusterSwitching] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [verified, setVerified] = useState(false);
  const [trackData, setTrackData] = useState(null);
  const [permission, setPermission] = useState(null);
  const [devicePosition, setDevicePosition] = useState({});
  const [contrLocation, setContrLocation] = useState({});
  const [storeBuildingMap, setStoreBuildingMap] = useState(null);
  const [phoneModel, setPhoneModel] = useState({ios: false, android: false});
  const [orientationListening, setOrientationListening] = useState(false);

  const value = useMemo(() => {
    const set = new Set(permissions ?? []);
    const can = (key) => set.has(key);

    return {
      token, setToken,
      userAuthority, setUserAuthority,
      cluster, setCluster,
      clusterSwitching, setClusterSwitching,
      permissions, setPermissions,
      can,
      verified, setVerified,
    };
  }, [token, userAuthority, cluster, clusterSwitching, permissions, verified]);

  const trackvalue = useMemo(() => ({trackData, setTrackData, permission, setPermission, devicePosition, setDevicePosition, contrLocation, setContrLocation, storeBuildingMap, setStoreBuildingMap, phoneModel, setPhoneModel, orientationListening, setOrientationListening}), [trackData, permission, devicePosition, contrLocation, storeBuildingMap, phoneModel, orientationListening]);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <LoginContext.Provider value={value}>
        <RedisHealthReconciliationBridge />
        <SnackbarProvider
          maxSnack={5}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          autoHideDuration={10000}
          preventDuplicate
          action={(snackbarId) => (
            <IconButton
              size="small"
              aria-label="close"
              onClick={() => closeSnackbar(snackbarId)}
              sx={{ color: "#fff" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        >
        <GlobalRealtimeStatus />
        <TargetContext.Provider value={trackvalue}>
          <ErrorBoundary>
            <Suspense fallback={<div style={{padding: 16}}>Loading…</div>}>
              <Routes>
                <Route path="/" element={<NewLogin />} />
                <Route path="/map" element={<MainPage />} />
                <Route path="/track" element={<TrackPage />} />
                <Route path="/whitelist" element={<WhiteList />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/account" element={<AccountPage />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
        </TargetContext.Provider>
        </SnackbarProvider>
        {/* <MainPage/> */}
      </LoginContext.Provider>
    </LocalizationProvider>
  )
};

export default App;
